//@helpers
const { APIGet } = require('utilities/APIRequestHelper');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
// @ constants
const actionTypes = require('constants/actionTypes');
const { CARD } = require('constants/ngoCategoryContexts');

const requestNgoListSuccess = data => ({
    type: actionTypes.NGO_FOUNDATION_LIST_SUCCESS,
    payload: {
        data
    }
});

const requestNgoListError = error => ({
    type: actionTypes.NGO_FOUNDATION_LIST_ERROR,
    payload: {
        error
    }
});

const requestNgoList = (originCountry, context = CARD) => (dispatch) => {
    const baseURL = apiURLBuilder.getURL("solidarity");

    const dataOngVersion = {
        header: {
            version: 2
        }
    };

    const urlNgoFromCountry = `${baseURL}/ngos?solidarityCorner=true&solidarity${context}=true&country=${originCountry}`;


    APIGet(() => {}, urlNgoFromCountry, dataOngVersion, true)
            .then(response => {
                dispatch(requestNgoListSuccess(response));
            })
            .catch(error => {
                dispatch(requestNgoListError(error));
            });
};

module.exports = {
    requestNgoList
};
